import React, {useEffect, useState} from "react";

/**
 * Returns an inline style object with animated opacity (0 → 1).
 * Optionally accepts delay and duration in milliseconds.
 */
export function useFadeIn({
                              delay = 0,
                              duration = 400
                          } = {}) {
    const [style, setStyle] = useState<React.CSSProperties>({
        opacity: 0,
        transition: `opacity ${duration}ms ease-in-out`,
    });

    useEffect(() => {
        const timeout = setTimeout(() => {
            setStyle((prev) => ({
                ...prev,
                opacity: 1,
            }));
        }, delay);

        return () => clearTimeout(timeout);
    }, [delay]);

    return style;
}
